module.exports = __webpack_public_path__ + "static/media/skin-3.f9045ad8.svg";